/**
 * @generated SignedSource<<162e0abf36eca50d7b8847725f49177c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespRefetchableSimilarItemsGrid_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemsGrid_item">;
  readonly " $fragmentType": "PdpRespRefetchableSimilarItemsGrid_item";
};
export type PdpRespRefetchableSimilarItemsGrid_item$key = {
  readonly " $data"?: PdpRespRefetchableSimilarItemsGrid_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespRefetchableSimilarItemsGrid_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespRefetchableSimilarItemsGrid_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2f41c0dfd18805a7adb4806b80076c51";

export default node;
